var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "brands_selection_padding" }, [
    _c(
      "div",
      {
        staticClass: "brands_selection_inner",
        style: {
          color: _vm.value.config.text_color,
          "background-image": "url(" + _vm.value.config.imageurl + ")",
        },
      },
      [
        _c("div", { staticClass: "text" }, [
          _vm._v(" " + _vm._s(_vm.value.config.title.slice(0, 4)) + " "),
        ]),
        _vm.goodsList.length
          ? [
              _c(
                "div",
                { staticClass: "content" },
                _vm._l(_vm.goodsList, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "item" },
                    [
                      _c("el-image", {
                        staticClass: "img",
                        attrs: { src: item.brand_logo, fit: "contain" },
                      }),
                      _c("div", { staticClass: "brand_name" }, [
                        _vm._v(_vm._s(item.brand_name)),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
              _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }